import React, { FC } from 'react';
import { Label, Tooltip } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// own components
import InfoIcon from './InfoIcon';

const Div = styled.div`
  margin: 1em 0;
`;

const StyledLabel = styled(Label)`
  margin-right: 0.25em;
`;

const ModerationHeader: FC = () => {
  return (
    <Div>
      <StyledLabel>Chat moderation:</StyledLabel>
      <Tooltip
        placement="right"
        content={`Changing the chat moderation setting
        will clear this chatroom's history.`}
      >
        <InfoIcon />
      </Tooltip>
    </Div>
  );
};

export default ModerationHeader;
